import { useState } from 'react'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import { Eye20Regular, EyeOff20Regular, Open12Regular } from '@/components/Icon'
import styles from './customModelDialog.module.scss'

/** A masked key field with a reveal toggle, the provider's format hint, and where to get a key. */
export default function ApiKeyField({ provider, value, error, saved, onChange }) {
  const [shown, setShown] = useState(false)
  const Toggle = shown ? EyeOff20Regular : Eye20Regular
  const placeholder = saved ? `Saved key ${saved.keyHint} · leave blank to keep it` : `Paste your ${provider.label} API key`
  const reveal = (
    <InputAdornment position="end">
      <IconButton size="small" edge="end" aria-label={shown ? 'Hide API key' : 'Show API key'} onClick={() => setShown((v) => !v)}>
        <Toggle />
      </IconButton>
    </InputAdornment>
  )
  return (
    <Box className={styles.section}>
      <label className={styles.label} htmlFor="custom-model-key">
        API key
      </label>
      <TextField
        id="custom-model-key"
        fullWidth
        variant="outlined"
        className={styles.input}
        type={shown ? 'text' : 'password'}
        value={value}
        placeholder={placeholder}
        error={Boolean(error)}
        autoComplete="off"
        onChange={(event) => onChange(event.target.value)}
        slotProps={{ htmlInput: { spellCheck: false, 'aria-describedby': 'custom-model-key-help' }, input: { endAdornment: reveal } }}
      />
      <Box id="custom-model-key-help" className={styles.helper}>
        <span className={error ? styles.error : undefined}>{error ?? `${provider.keyHint}.`}</span>
        {provider.keyUrl ? (
          <a className={styles.keyLink} href={provider.keyUrl} target="_blank" rel="noopener noreferrer">
            Get a key
            <Open12Regular aria-hidden />
          </a>
        ) : null}
      </Box>
    </Box>
  )
}
